import {makeEl} from "../../common/Utils";
import DataStore from "../DataStore";
import {svgIcoBtnChange, svgIcoChangeList} from "../SvgCode";
import Layer from "../Layer";
import { countryType, langType, IlanguageCountry } from '../../interface/IFooter';

export default  class LanguageCountry{
    private ds: DataStore;
    private btn!: HTMLButtonElement;
    private ul!: HTMLUListElement;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.languageCountryList && this.ds.config.languageCountryList.length> 0){
            this.templ(_wrapper);
            this.addEvents();
        }
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-change-inner footer-change-lanco'});
        this.btn = makeEl('button', tmpl, {class: 'btn-footer-change'});
        this.ul = makeEl('ul', tmpl, {class: 'footer-change-list', id: 'FooterLanguageCountryChangeList'});
        this.ds.config.languageCountryList.map(it => this.liTempl(this.ul, it, svgIcoChangeList));
    }

    liTempl(_parent: HTMLUListElement, _data: IlanguageCountry, _svgCode: string){
        const li = makeEl('li', _parent, {class: 'footer-change-item'});
        const path = _data.path? _data.path: _data.code;
        const aEl = makeEl('a', li, {class: 'change-item-link', href: '/'+path+'/index', 'data-code': _data.code});

        if(_data.code.toLowerCase() === this.ds.lang+'-'+this.ds.country.toLowerCase()){
            aEl.innerHTML= _svgCode;
            makeEl('strong', aEl, undefined, _data.title);
            this.btn.innerHTML= `<span class="inner-txt">${_data.title}</span>${svgIcoBtnChange}`;
        } else {
            makeEl('span', aEl, undefined, _data.title);
        }
    }

    addEvents(){
        this.btn.addEventListener('click', e => {
            Layer.toggleLayer(this.ul.id);
            e.stopPropagation();
        });
    }
}
